import { IncomeType } from './hooks/useIncomes';

export const incomeTypeOptions: { value: IncomeType; label: string }[] = [
  { value: 'Income', label: 'Income' },
  { value: 'Benefit', label: 'Benefit' },
  { value: 'Employment', label: 'Employment' },
  { value: 'ShareOrDividend', label: 'Share or dividend' },
  { value: 'Rental', label: 'Rental' },
  { value: 'Pension', label: 'Pension' },
];

export function labelForIncomeType(value: string): string {
  return incomeTypeOptions.find(option => option.value === value)?.label ?? value;
}
